import Api from "./Api.js";
const resource = "/feature-flags";

export default {
  isFeatureFlagEnabled(flagName) {
    return Api.get(`${resource}/${flagName}`);
  },
};